import { render } from "./Main.vue?vue&type=template&id=a7bf5a08"
const script = {}
script.render = render

export default script